import React from "react";
import arrow from "../svg/arrow.svg";
import heroText from "../svg/hero-text.svg";

export default function Footer() {
  return (
    <footer className="bg-black text-white font-Neuehaasdisplay font-light mt-20">
      <div className="flex flex-col md:flex-row justify-between items-center mx-5 py-10">
        {/* Hero text on the left - 80% width and white */}
        <div className="w-[80%] flex items-center justify-start mb-5 md:mb-0">
          <img
            src={heroText}
            alt="Stunner Rave"
            className="w-full h-auto filter brightness-0 invert"
          />
        </div>
        {/* Instagram and email on the right */}
        <div className="items-center flex text-center">
          <ul className="space-y-3 underline uppercase flex flex-col items-center md:text-base text-sm tracking-[1px] text-white">
            <li>
              <a
                href="https://instagram.com/stunnerave"
                className="flex items-center text-center"
              >
                <img
                  src={arrow}
                  alt="arrow up"
                  className="stroke-white w-4 mr-1 filter brightness-0 invert"
                />
                Instagram
              </a>
            </li>
            <li>
              <a href="mailto:stunnerrave@gmail.com" className="flex">
            STUNNERRAVE@GMAIL.COM
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
